/**
 * Subscription plan reference data (T12, frontend-only). Single source for the
 * Settings Billing/Team plan labels, picker order, and per-plan feature copy —
 * pages import these instead of inlining plan arrays. Mirrors the backend
 * billing catalog until a server-driven source replaces it.
 */

/** Plan key → display label (Billing status card, Team seat bar, invoices). */
const PLAN_LABEL = { trial: 'Trial', starter: 'Starter', shop: 'Shop', pro: 'Pro' };

/** Plan picker order per the .pen Billing frame. */
const PLAN_ORDER = ['starter', 'shop', 'pro'];

/** Per-plan feature bullets shown on the Billing plan cards. The `{seats}` token is
 * filled at render time from the server-provided `seat_cap` (Billing.jsx), so the seat
 * count is never hardcoded here — it can never drift from the backend PLAN_SEAT_CAPS. */
const PLAN_FEATURES = {
  starter: ['Inventory & sold-cleanup', 'eBay', 'Donor ROI'],
  shop: ['Everything in Starter', '{seats} team seats', 'Priority support'],
  pro: ['Everything in Shop', '{seats} team seats', 'Advanced reports'],
};

export {
  PLAN_FEATURES,
  PLAN_LABEL,
  PLAN_ORDER,
};
